import React, { useState, useContext } from 'react';
import { Box, Button, Tab, Tabs } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import TabPanel from '../../components/TabPanel';
import ListIcon from '@mui/icons-material/List';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
// Providers
import { DashboardProvider } from '../Dashboard/useDashboard';
// API
import AppConst from '../../components/AppLayout/const';
// Component
import Filter from './components/Filter';
import ViewMDProfileDialog from './components/ViewMDProfileDialog';
import MdProfileProvider from './context/useMdProfileContext';
import MDList from './components/MDList';
import MDGrid from './components/MDGrid';
import { useMdProfileContext } from './context/useMdProfileContext';

const MDProfilePage = () => {
  // Wrap MD Profile Dashboard to Provider
  return (
    <DashboardProvider>
      <MdProfileProvider>
        <MdProfileDashboard />
      </MdProfileProvider>
    </DashboardProvider>
  );
};

// MdProfileDashboard Content
const MdProfileDashboard = () => {
  const { viewProfile } = useContext(useMdProfileContext);
  const { onSetTitle } = useContext(AppConst.AppContext);
  const [activeTab, setActiveTab] = useState(0);
  onSetTitle('MD Profile Dashboard');

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
        <Filter />
      </Box>
      <Box padding={4}>
        <Box>
          <Box>
            <Grid container spacing={2}>
              <Grid xs={12} sm={12} md={12}>
                <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                  <Box
                    display='flex'
                    justifyContent='flex-end'
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                  >
                    <Tabs
                      value={activeTab}
                      onChange={handleChangeActiveTab}
                      aria-label='basic tabs example'
                    >
                      <Tab
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ListIcon />
                            LIST
                          </Box>
                        }
                        id='md-profile-dashboard-list-tab'
                        aria-controls='md-profile-dashboard-list-tab'
                      />

                      <Tab
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ViewModuleIcon />
                            GRID
                          </Box>
                        }
                        id='md-profile-dashboard-grid-tab'
                        aria-controls='md-profile-dashboard-grid-tab'
                      />
                    </Tabs>
                  </Box>
                  <TabPanel value={activeTab} index={0}>
                    <MDList />
                  </TabPanel>
                  <TabPanel value={activeTab} index={1}>
                    <MDGrid />
                  </TabPanel>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      {viewProfile?.toggle ? <ViewMDProfileDialog /> : ''}
    </Box>
  );
};

export default MDProfilePage;
